import { useCallback } from 'react'
import { PdfConfigTemplateSingleTy } from '../../types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { PdfConfigTemplateTabProps } from '../types'
import { addAntiUnsaveElement } from '../../../../../../../../utils/reducers/reduxDispatch'

interface ModalConfigPdfDeletePageProps extends ModalConfigPdfDeletePageLogicProps { }

const ModalConfigPdfDeletePage: React.FC<ModalConfigPdfDeletePageProps> = ({ setOpenModal, ...rest }) => {
    const { removePage } = useModalConfigPdfDeletePageLogic({ ...rest, setOpenModal })
    const { t } = useTwinTranslation()
    return (
        <ModalDeleteFilled opened={true} setOpened={() => setOpenModal(null)} onCancel={() => setOpenModal(null)} onAccept={removePage} translations={{
            title: t('sureDeletePage', '¿Seguro que quieres eliminar esta página?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminada no podrás recuperarla')
        }} className='modal_delete_page_pdf' />
    )
}

interface ModalConfigPdfDeletePageLogicProps extends PdfConfigTemplateTabProps {
    myKey: number
}

const useModalConfigPdfDeletePageLogic = ({ setConfig, myKey }: ModalConfigPdfDeletePageLogicProps) => {
    const { t } = useTwinTranslation()
    const pageName = t('page', 'Página')
    const removePage = useCallback(async () => {
        await addAntiUnsaveElement(['pdf_template_changes', '{}'])
        let myPageKey: number | null = null
        const splitKey = String(myKey).split('page')
        myPageKey = parseInt(splitKey[1])
        if (myKey) {
            setConfig((old) => {
                const copy: PdfConfigTemplateSingleTy = JSON.parse(JSON.stringify(old))
                copy.pages.splice(myPageKey!, 1)
                for (const element of copy.pages) {
                    element.name = pageName + ' ' + (copy.pages.indexOf(element) + 1)
                }
                return { ...copy }
            })
        }

    }, [setConfig, myKey, pageName])
    return { removePage }
}

export default ModalConfigPdfDeletePage